import React from 'react'; 
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import WithConsumer from '../../context/WithConsumer';
import Image from '../global/Image';
import { Link } from 'react-router-dom';
import PageFooter from '../page/PageFooter';
import Thumbnails from './Thumbnails';
import ScrollToTop from '../global/ScrollToTop';

const Projects = ({ context }) => {
	
	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    if (post) {
	    
	    if (post.data) {
				    
		    let pageClass = 'c-page-wrapper c-page state-not-loaded c-page-' + post.slug;
			if (pageLoaded == true) {
				pageClass = 'c-page-wrapper c-page state-loaded c-page-' + post.slug;
	    	}
	    	      						    
		    if (pageLoaded == true) {
				document.body.style.backgroundColor = '#24272a';
		    }
		   		    
			if (context.appError){
				return null; 
			} else {
					
				return (
					
					<>
						<div className={pageClass}>
							<ScrollToTop></ScrollToTop>
					
							<div className="c-page__block c-page__block--charcoal">
			    	
						    	<Thumbnails block={post.data[0]}></Thumbnails>						    					    				    				    
						    </div>
							
						</div>
						
						<PageFooter post={post.data[0]}></PageFooter>
					</>
				)
					
			}
			
		} else {
			
			return null;
		}

	} else {
		return null;
	}
};
export default WithConsumer(Projects);